module.exports = __webpack_public_path__ + "static/media/bts_lalela_170710_015_small.ae769344.jpg";